<template>
  <div class="qr-code-container j-qr-code-container">
    <p class="txt-tips" v-html="qrCodeTipe"></p>
    <!--登录前，现实登录二维码，移动端扫码登录，然后跳转到移动单h5-->
    <!--登录后，显示未加载状态-->
    <!--登录后，五分钟后，二维码过期显示过期状态-->
    <div
      class="qr-code-wrapper j-load-qr-code"
      v-on:click="loadQRCode"
      v-bind:class="{
        qrcodeWrapperLogined: user.id && !showQrCode,
        qrCodeWrapperLoaded: user.id && showQrCode && !timeout,
        qrCodeWrapper: !user.id
      }"
    >
      <div class="line" v-if="user.id && !showQrCode"></div>
      <div
        class="img-tips"
        v-if="user.id && !showQrCode"
        v-bind:class="{
          load: beforeLaodQrCode && !timeout,
          refresh: !beforeLaodQrCode && timeout
        }"
      ></div>
      <img
        class="qr-code-img"
        v-if="!user.id || (showQrCode && !timeout)"
        :src="qrCodeSRc"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getAllParamsFromHref } from "../store/ultile";

const qrCodeAjax =
  "//passport.gm99.com/ajax/h5_qrcode?" + getAllParamsFromHref(true);

export default {
  data() {
    return {
      showQrCode: false,
      timeout: false,
      beforeLaodQrCode: true
    };
  },
  computed: {
    qrCodeSRc() {
      var timesmap = new Date().getTime();
      if (!this.user.id || (this.showQrCode && !this.timeout)) {
        return qrCodeAjax + "&v=" + timesmap;
      }
      return "";
    },
    qrCodeTipe() {
      if (this.timeout && !this.showQrCode && this.user.id) {
        return "您的QR CODE<br>已失效";
      }
      return "用手機掃一下也能<br>在手機上玩唷~";
    },
    ...mapGetters(["user"])
  },
  methods: {
    loadQRCode() {
      if (this.showQrCode) {
        return "";
      }
      this.timeout = false;
      this.showQrCode = true;
      this.beforeLaodQrCode = false;
      setTimeout(() => {
        this.timeout = true;
        this.showQrCode = false;
      }, 1000 * 60 * 5);
      /*
                二维码的状态：未登录，未加载，已加载 ， 已过时
                未登录 beforeLaodQrCode值为true。显示一张登录跳转的二维码。登录后，点击加载后，值变为true.
                未加载 显示点击加载二维码的提示 showQrCode 控制二维码的显示情况。点击后showQrCode 为true.
                已过时 当二维码显示超过五分钟后，会过期，需要提示用户重新点击加载一个新的二维码。
            */
    }
  }
};
</script>

<style lang="scss">
$pcImgUrl: "../assets/img/pc/";
.qr-code-container {
  width: 212px;
  height: 223px + 8px + 26px * 2;
  position: absolute;
  right: -212px - 40px;
  bottom: 40px;
  .txt-tips {
    width: 100%;
    text-align: center;
    line-height: 26px;
    font-size: 18px;
    font-weight: bolder;
    color: white;
  }
  .qr-code-wrapper {
    width: 212px;
    height: 223px;
    margin-top: 8px;
    display: table-cell;
    vertical-align: middle;
    position: relative;
    cursor: pointer;
    text-align: center;
    &.qrcodeWrapperLogined {
      background: url($pcImgUrl+"getQRCodeLog.png");
      &:hover {
        background: url($pcImgUrl+"getQRCodeLog-hover.png");
      }
    }
    &.qrCodeWrapperLoaded,
    &.qrCodeWrapper {
      background: url($pcImgUrl+"qrCodeBg.png");
    }
    .img-tips {
      width: 110px;
      height: 67px;
      margin: 0 auto;
      &.load {
        background: url($pcImgUrl+"loadQRTips.png");
      }
      &.refresh {
        background: url($pcImgUrl+"refreshQRCodeTip.png");
      }
    }
    .line {
      width: 447px;
      height: 8px;
      position: absolute;
      top: 77px;
      left: (212px - 447px)/2;
      background: url($pcImgUrl+"qrCodeLine.png");
    }
  }
  .qr-code-img {
    width: 183px;
    height: 183px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/QrCode.vue